import React          from 'react'
import PropTypes      from 'prop-types'
import {START}        from 'pu-data/QuoteSteps'
import ParametersShow from '../../data/ParametersShow';

const copper = (props) => {
  let text = `${props.parameters.copper_outers} Cu Outer`;
  if (props.parameters.number_of_layers !== 2) {
    text = `${text}, ${props.parameters.copper_inners} Cu Inner`
  }
  return text
}

const ParameterList = (props) => {
  const {parameters} = props

  // const copperInners = parameters.get('copper_inners')
  // const copperOuters = parameters.get('copper_outers')

  const showValue = name => (ParametersShow.value(name, parameters[name], parameters) || ' ');

  return (
    <div className={`parameters-list ${props.className}`}>
      <div className="box"/>
      <strong>{props.label} </strong><br/>
      {showValue('material_thickness')}{', '}
      {showValue('finish_plating')}{', '}
      {showValue('material_type')}{', '}
      {showValue('solder_color')} Soldermask{', '}
      {showValue('silkscreen_color')} Silkscreen{', '}
      {copper(props)}
    </div>
  )
}

ParameterList.propTypes = {
  label: PropTypes.string.isRequired,
  parameters: PropTypes.object.isRequired,
  className: PropTypes.string,
}


const Parameters = (props) => {
  const {quoteStep, showSummary} = props;

  if (quoteStep === START) return null;
  if (showSummary) return null;

  // const existsBlueRow = props.usCombined.get('matrix').valueSeq().map(a => a.keySeq())
  //   .flatten()
  //   .indexOf('grpa') >= 0;

  const existsBlueRow = Object.values(props.usCombined.matrix).map(a => Object.keys(a)).flat().indexOf('grpa') >= 0;
  if (!existsBlueRow) return null;

  return (
    <div className="parameters-lists border-bottom pb-3">
      <ParameterList label="White Rows Show Prices Using Your Chosen Specs"
                     parameters={props.parametersCustomer}/>
      <ParameterList label="Blue Rows Show LOWER PRICES Using Standard Specs"
                     parameters={props.parametersBestPrice} className="best-price"/>
    </div>
  )
}

Parameters.propTypes = {
  usCombined: PropTypes.object.isRequired,
  parametersCustomer: PropTypes.object.isRequired,
  parametersBestPrice: PropTypes.object,
}


export default Parameters;
